/**
 *
 * @author Overture Web Development LLC
 *
 */
!function () {
	const notifyMeForm = document.querySelector("#notifyMeForm");
	const submitBtn = document.querySelector("#nm-submit");
	const email = document.querySelector("#nm-emailAddress");
	const responseMessage = document.querySelector("#responseMessage");
	const statuses = {
		true: {
			message: "Thanks, we'll be in touch very soon!",
			color: "default",
			class: "success"
		},
		false: {
			message: "Please enter a valid email address.",
			color: "red",
			class: "error"
		},
		error: {
			message: "Oops. Something went wrong.",
			color: "red",
			class: "error"
		},
	};

	if (!notifyMeForm) return;

	const submitHandler = async (e) => {
		e.preventDefault();
		e.stopPropagation();
		const data = new FormData(e.target);
		try {
			const response = await fetch("https://www.overtureweb.com/excelfilters/", {
				method: "POST",
				body: data,
			});
			const status = await response.json();
			responseMessage.innerHTML = statuses[status].message;
			responseMessage.setAttribute("class", "");
			responseMessage.classList.add(statuses[status].class, "d-block");
			if (status) {
				submitBtn.setAttribute('disabled', "true");
				email.setAttribute('disabled', "true");
			}
		} catch (err) {
			console.log(`Error: ${err.message}`)
			responseMessage.innerHTML = statuses.error.message;
			responseMessage.classList.add(statuses.error.class, "d-block");
		}
	}

	document.addEventListener("submit", submitHandler);


}();
